export const config = {
  title: "Sign Rescue Pros | Custom Sign Making in Houston, TX",
  meta: {
    description:
      "Sign Rescue Pros specializes in custom sign making in Houston, TX. We offer sign design, manufacturing, maintenance, and installation services to enhance business visibility.",
    keywords: [
      'Custom Sign Making Houston',
      'Electric Sign Design',
      'Sign Manufacturing',
      'Sign Installation',
      'Sign Maintenance',
      'Sign Rescue Pros',
      'Houston TX Signs',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Sign Rescue Pros",
    canonicalUrl: 'https://signrescuepros.com/',
  },
  sections: {
    header: {
      businessName: "Sign Rescue Pros",
    },
    sectionB: {
      heroTitle: "Sign Rescue Pros",
      heroSubtitle: 'Crafting Custom Signs for Maximum Visibility',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '5128096513',
      phoneLabel: '(512) 809-6513',
      heroBackgroundImage:
        'https://signrescuepros.com/wp-content/uploads/2025/01/04.jpg',
      cardData: [
        {
          title: 'Eco-friendly Materials',
          description:
            'We prioritize sustainability in every sign we create.',
        },
        {
          title: 'Dynamic Digital Displays',
          description:
            'Incorporating motion and interactive features for impact.',
        },
        {
          title: 'Minimalist Design',
          description:
            'Clean, modern aesthetics tailored to your brand.',
        },
      ],
      description:
        "At Sign Rescue Pros, we bring your brand to life through expert sign design and production. Our Houston-based team ensures high-quality, long-lasting signage that grabs attention and enhances business recognition.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Explore our extensive range of signage solutions, crafted to meet business and promotional needs.",
      cards: [
        {
          title: 'Custom Sign Making',
          description:
            'Tailored signage solutions for businesses of all sizes.',
          imageSrc:
            'https://signrescuepros.com/wp-content/uploads/2025/01/Sign-Making.jpg',
          imageAlt: 'Custom Sign Making',
        },
        {
          title: 'Electric Signage',
          description:
            'High-quality illuminated signs to enhance brand visibility.',
          imageSrc:
            'https://signrescuepros.com/wp-content/uploads/2025/01/Electric-Sign-Making.jpg',
          imageAlt: 'Electric Sign Making',
        },
        {
          title: 'Sign Maintenance & Repair',
          description:
            'Regular servicing and repairs to keep your signs in pristine condition.',
          imageSrc:
            'https://signrescuepros.com/wp-content/uploads/2025/01/Sign-Maintenance.jpg',
          imageAlt: 'Sign Maintenance',
        },
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://signrescuepros.com/wp-content/uploads/2025/01/01.jpg',
        alt: "Sign Rescue Pros Team",
      },
      aboutText: [
        "Sign Rescue Pros is Houston’s trusted expert in sign design, manufacturing, and maintenance. We work closely with businesses to create signage that stands out and drives customer engagement.",
        "We envision a future where businesses across Houston benefit from high-quality, durable, and visually compelling signs. Our team is committed to excellence in every project, ensuring your brand gets the attention it deserves.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Sign Rescue Pros Logo",
      businessName: "Sign Rescue Pros",
      contact: {
        phone: '5128096513',
        phoneLabel: '(512) 809-6513',
        email: 'ian@signrescuepros.net',
        website: 'https://signrescuepros.com/',
        address: 'Houston, TX 77070, USA',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Houston, TX 77070, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3470.8145798346215!2d-95.55121428492412!3d29.98585317940285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c5d5e5e4d6b3%3A0xabcdef123456789!2sHouston%2C%20TX%2077070%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
